/*
  <accordion-group>: only one <details data-accordion-item> open at a time, with
  a short height/fade animation on its [data-accordion-content] element.
  Used by the FAQ section and the product page tabs. Without JavaScript the
  <details name="..."> attribute still keeps one item open at a time (no animation).
*/
if (!customElements.get('accordion-group')) {
  customElements.define(
    'accordion-group',
    class AccordionGroup extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('details[data-accordion-item]'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items.forEach((item) => {
          // The script handles exclusivity itself, so the browser must not close items instantly
          item.removeAttribute('name');
          item.querySelector('summary').addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(item);
          });
        });
      }

      toggle(item) {
        if (item.open && !item.dataset.closing) {
          this.close(item);
          return;
        }

        this.items.forEach((other) => {
          if (other !== item && other.open) this.close(other);
        });
        this.open(item);
      }

      open(item) {
        const answer = item.querySelector('[data-accordion-content]');
        item.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
        delete item.dataset.closing;
        item.open = true;

        if (this.reducedMotion.matches) return;

        answer.animate(
          [
            { height: '0px', opacity: 0 },
            { height: `${answer.scrollHeight}px`, opacity: 1 },
          ],
          { duration: 250, easing: 'ease-out' }
        );
      }

      close(item) {
        const answer = item.querySelector('[data-accordion-content]');
        item.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());

        if (this.reducedMotion.matches) {
          item.open = false;
          return;
        }

        item.dataset.closing = 'true';
        const animation = answer.animate(
          [
            { height: `${answer.offsetHeight}px`, opacity: 1 },
            { height: '0px', opacity: 0 },
          ],
          { duration: 250, easing: 'ease-out' }
        );
        animation.onfinish = () => {
          item.open = false;
          delete item.dataset.closing;
        };
      }
    }
  );
}
